<template>
	<vs-dialog v-model="active" width="800px" @close="borrarInfo" prevent-close>
      <template #header>
      <h4 class="not-margin">
          Crear rol
      </h4>
      </template>
      <div class="con-form">
        <vs-row>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter  class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Rol <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-input class="pt-0" v-model="rol" placeholder="Rol" >
                        <template #message-danger v-if="errorFields.includes('rol')">
                            Requerido
                        </template>
                    </vs-input>
                </form>
            </vs-col>
        </vs-row>
      </div>

      <template #footer>
      <div class="footer-dialog">
            <vs-row>
                <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat
                    @click="borrarInfo()">
                    Cancelar
                </vs-button>
                </vs-col>
                <vs-col sm="6" lg="6">
                <vs-button
                    success
                    class="ml-auto"
                    @click="postCrearRol()">
                    Guardar
                </vs-button>
                </vs-col>
            </vs-row>
      </div>
      </template>
  </vs-dialog>
</template>

<script>
import accesibilidad from '../../../../../api/requests/accesibilidad'
export default {
	props:[
	  'value',
      'instituciones',
      'institucionId'
  ],
  data () {
      return {
          active: false,
          institucion: '',
          rol: '',
          errorFields:[]
      }
  },
  methods: {
    sanityForm () {
        this.errorFields = []
        if (!this.institucion) {
            this.errorFields.push('institucion')
        }
        if (!this.rol) {
            this.errorFields.push('rol')
        }
        if (!this.errorFields.length){
            
            return true
        } else {
            return null
        }
    },
    async postCrearRol(){
        if(this.sanityForm()){
            const loading = this.$vs.loading()
            try{
                const datos = {
                    institucion_id: this.institucion,
                    rol: this.rol
                }
                const { data: response } = await accesibilidad.postCrearRol(datos)
                const rol_id = response.id
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'Se ha creado el rol con éxito'
                })
                this.$emit('refreshTable', this.institucion, rol_id)
                this.borrarInfo()
            }catch(error){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    duration: 10000,
                    title: 'Se produjo un error',
                    text: error.response.data.message
                })
            }
        }
    },
    borrarInfo(){
        this.active = false
        this.institucion = ''
        this.rol = ''
    }
  },
  watch: {
    value (val) {
      this.active = val
    },
  }
}
</script>
